var exports = {
  "kL": "ReportFlowScreenView.module__container___WWVxZ2",
  "uW": "ReportFlowScreenView.module__section___WWVxZ2",
  "R_": "ReportFlowScreenView.module__heading___WWVxZ2",
};

module.exports = exports;
